import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { Color } from "@msuite/utils/colors";
import type { IncomingEmailListItem } from "@msuite/utils/types";

/** Props Interface */
interface IncomingEmailOutcomeTagProps {
	outcome: IncomingEmailListItem["outcome"];
}

const OUTCOME_COLOR: Record<IncomingEmailListItem["outcome"], Color> = {
	stored: "emerald",
	skipped: "amber",
	failed: "rose",
};

export function IncomingEmailOutcomeTag({ outcome }: IncomingEmailOutcomeTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			color={OUTCOME_COLOR[outcome]}
			variant="plain"
		>
			{t(`mailboxes.outcome.${outcome}`)}
		</Tag>
	);
}
